import script from "./ReportesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportesComponent.vue?vue&type=script&setup=true&lang=js"

import "./ReportesComponent.vue?vue&type=style&index=0&id=cf2a4fe0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf2a4fe0"]])

export default __exports__